// extracted by mini-css-extract-plugin
export default {"container":"ArticleForm_container__HK8+O","tab":"ArticleForm_tab__8yD9M","loaderContainer":"ArticleForm_loaderContainer__ysrfr"};